import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {OrbitSwiperComponent} from '../orbit-swiper/orbit-swiper.component';
import {observer} from 'mobx-react';
import {CyClass} from "../../../common/cy-classes";
import {ISwiperListViewModel} from "../../services/arenas/models/lists/swiper-list-view-model.interface";

interface BecauseYouPlayedComponentProps {
    viewModel: ISwiperListViewModel;
    listPosition: number;
}

export const BecauseYouPlayedComponent = observer(
    class BecauseYouPlayedComponent extends OrbitComponent<BecauseYouPlayedComponentProps> {
        
        componentDidMount() {
            super.componentDidMount();

            this.reaction(() => this.services.runningGame.correlatedGamesForLastPlayedRealGame,
                (correlatedGames) => {
                    this.props.viewModel.swipeLogicHandler.resetScrollPosition();
                }
            );
        }
        
        render() {
            const viewModel = this.props.viewModel;
        
            return (
                <div className={CyClass('cy-because-you-played')}>
                    <OrbitSwiperComponent
                        viewModel={viewModel}
                        listPosition={this.props.listPosition}
                        skipIntermediatePage={true}
                    />
                </div>
            );
        }
    }
);
